import { TableHead as TableHeadMui, TableHeadProps as TableHeadMuiProps } from '@mui/material';

export type TableHeadProps = TableHeadMuiProps;

export const TableHead = TableHeadMui;
